import { render, staticRenderFns } from "./PopChoose.vue?vue&type=template&id=0cc2a422&scoped=true&"
import script from "./PopChoose.vue?vue&type=script&lang=js&"
export * from "./PopChoose.vue?vue&type=script&lang=js&"
import style0 from "./PopChoose.vue?vue&type=style&index=0&id=0cc2a422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2a422",
  null
  
)

export default component.exports